import template from './login.html';
import controller from './login.controller';
import './login.scss';

let loginComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default loginComponent;



// WEBPACK FOOTER //
// ./client/app/components/login/login.component.js